import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import styled from 'styled-components/macro';
import TocIcon from '@material-ui/icons/Toc';
import Tooltip from '@material-ui/core/Tooltip';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Animation from '../Animation';
import { IconButton } from '@material-ui/core';
import { SimpleFlexContainer } from '../layouts/ng-layouts/Containers';
import Colors from '../../internal-components/Colors';
import useTranslations from '../../hooks/useTranslations';

const Link = styled.a`
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  color: ${({ $current }) => ($current ? Colors.PRIMARY : Colors.DARK_GREY)};
  transition: 0.3s;
  cursor: pointer;

  &:before {
    content: '${({ $current }) => ($current ? '―' : '')}';
    color: ${Colors.PRIMARY};
    font-size: 14px;
    position: absolute;
    left: -5px;
  }
`;

const Container = styled.div`
  position: absolute;
  max-width: 300px;
  max-height: 75%;
  overflow: ${({ $expanded }) => ($expanded ? 'auto' : 'hidden')};
`;

const H3 = styled.h3`
  color: ${Colors.DARK_GREY};
  margin: 0.8rem 1rem;
  font-weight: 500;
  font-size: 14px;
`;

const ListItem = styled.span`
  margin: 0.8rem 1rem;
`;

const FormTOCView = props => {
  const t = useTranslations();

  return (
    <>
      <Container>
        <Animation
          type="slide"
          direction="right"
          in={!props.expanded && !props.isScreen2Small}
        >
          <Tooltip title={t('form.toc.closed.tooltip')} arrow>
            <IconButton style={{ zIndex: 2 }} onClick={props.toggleExpanded}>
              <ListAltIcon />
            </IconButton>
          </Tooltip>
        </Animation>
      </Container>
      <Container $expanded={props.expanded && !props.isScreen2Small}>
        <Animation
          exit={false}
          type="slide"
          direction="right"
          in={props.expanded && !props.isScreen2Small}
          style={{ transitionDelay: '150ms' }}
        >
          <SimpleFlexContainer>
            <span>
              <IconButton onClick={props.toggleExpanded}>
                <ArrowBackIcon />
              </IconButton>
            </span>
            <H3>{t('form.toc.title')}</H3>
            <SimpleFlexContainer>
              {props.sections.map((section, i) =>
                !section.title ? null : (
                  <ListItem key={section.internalId}>
                    <Link
                      onClick={() => props.onLinkClicked(i)}
                      $current={i === props.currentSection}
                    >
                      {section.title}
                    </Link>
                  </ListItem>
                )
              )}
            </SimpleFlexContainer>
          </SimpleFlexContainer>
        </Animation>
      </Container>
    </>
  );
};

export default FormTOCView;
